module.exports = __webpack_public_path__ + "img/VP-Standard_Overview-Front_2.05a5d505.jpg";